import React from "react";
import { Heading } from "../../../design/heading";
import { Card } from "../../../design/card";
import { Button } from "../../../design/button";
import { Text } from "../../../design/text";
import ParentingPlanStatusBadge from "../../../components/Badges/ParentingPlanStatusBadge";
import { useParentingPlan } from "../../../contexts/ParentingPlanContext";
import moment from "moment";
import ParentingPlanButton from "../../../components/ParentingPlanButton";

interface Props {}

const CurrentParentingPlan: React.FC<Props> = ({}) => {
  const { currentParentingPlan } = useParentingPlan();

  if (!currentParentingPlan) {
    return (
      <Card>
        <Heading level={5}>Parenting Plan</Heading>
        <Text>No current parenting plan available.</Text>
        <ParentingPlanButton />
      </Card>
    );
  }

  return (
    <Card>
      <Heading level={5}>Parenting Plan</Heading>
      <Text>{currentParentingPlan?.name}</Text>
      <Text className="text-sm text-gray-500">
        Status:{" "}
        <ParentingPlanStatusBadge
          status={currentParentingPlan?.status ?? "draft"}
        />
      </Text>
      {currentParentingPlan?.updatedAt && (
        <Text>
          Last updated:{" "}
          {moment(currentParentingPlan.updatedAt).format("MMMM Do YYYY")}
        </Text>
      )}
      <Button
        className="mt-2"
        href={`/parenting-plan/${currentParentingPlan?._id}`}
      >
        View Plan
      </Button>
    </Card>
  );
};

export default CurrentParentingPlan;
